module.exports = __webpack_public_path__ + "static/media/vasabron.f10f12c9.png";